/* Bajar los vales de gasoil de la base a Excel.
 *
 * Mismo criterio que `exportarUrea`, del que toma la fecha: sale LO QUE ESTÁ
 * EN PANTALLA —el período, el filtro y el orden elegidos—, no una consulta
 * aparte. El que baja el archivo lo compara contra la pantalla desde la que lo
 * bajó.
 *
 * Además de las cargas, una hoja por cada total (día, mes, chofer, unidad):
 * son las cuentas que la pantalla muestra, hechas por `shared/gasoil.totales`,
 * así que el Excel y la pantalla suman lo mismo.
 */

import { fechaHora } from "./exportarUrea";
import { AGRUPACIONES, totales } from "../shared/gasoil";

export const CABECERA = ["Cuándo", "Vale", "Litros", "Chofer (vale)",
  "Chofer (padrón)", "Patente", "Interno", "Tipo", "Referencia", "Km",
  "Importe", "Cargó", "Foto del vale"];

const TIPO = { tractor: "tractor", furgon: "furgón", utilitario: "utilitario" };

/* Un número o vacío. Nunca un cero inventado: vacío es «no lo sabemos». */
const num = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const n = Number(v);
  return Number.isFinite(n) ? n : "";
};

export function comoMatriz(filas) {
  return [
    CABECERA,
    ...(filas || []).map((c) => [
      fechaHora(c.fecha),
      c.vale || "",
      num(c.litros),
      c.chofer || "",
      c.chofer_padron || "",
      c.patente || "",
      c.interno || "",
      TIPO[c.unidad_tipo] || "",
      c.referencia || "",
      num(c.km),
      num(c.importe),
      c.quien_nombre || c.quien || "",
      c.foto ? "sí" : "no",
    ]),
  ];
}

/* La hoja de un total: el renglón, cuántas cargas y cuántos litros. */
export function matrizDeTotales(filas, por) {
  const titulo = (AGRUPACIONES.find((a) => a.id === por) || {}).label || por;
  return [
    [titulo, "Cargas", "Litros"],
    ...totales(filas, por).map((g) => [g.rotulo, g.cargas, g.litros]),
  ];
}

export function nombreArchivo(desde, hasta) {
  if (!desde && !hasta) return "gasoil-base";
  if (desde === hasta) return `gasoil-base-${desde}`;
  return `gasoil-base-${desde || "inicio"}_a_${hasta || "hoy"}`;
}

export async function aExcel(filas, desde, hasta) {
  const XLSX = await import("xlsx");
  const libro = XLSX.utils.book_new();
  const hoja = XLSX.utils.aoa_to_sheet(comoMatriz(filas));
  hoja["!cols"] = [{ wch: 17 }, { wch: 10 }, { wch: 9 }, { wch: 24 },
                   { wch: 26 }, { wch: 10 }, { wch: 8 }, { wch: 8 },
                   { wch: 12 }, { wch: 10 }, { wch: 10 }, { wch: 22 },
                   { wch: 12 }];
  hoja["!freeze"] = { xSplit: 0, ySplit: 1 };
  XLSX.utils.book_append_sheet(libro, hoja, "Vales de gasoil");
  for (const a of AGRUPACIONES) {
    const t = XLSX.utils.aoa_to_sheet(matrizDeTotales(filas, a.id));
    t["!cols"] = [{ wch: 30 }, { wch: 8 }, { wch: 10 }];
    XLSX.utils.book_append_sheet(libro, t, `Por ${a.label.toLowerCase()}`);
  }
  XLSX.writeFile(libro, `${nombreArchivo(desde, hasta)}.xlsx`);
}

